export default "__VITE_ASSET__gNkAIhEc__"